import { TaxCouponItemIssqn } from '@/core/domain/coupon/coupons/coupons.item.types';
import { Select, SelectProps } from 'antd';
import { forwardRef } from 'react';

const data = [
  { value: TaxCouponItemIssqn.DEMANDABLE, label: 'Exigível' },
  {
    value: TaxCouponItemIssqn.NON_INCIDENCE,
    label: 'Sem Incindência',
  },
  { value: TaxCouponItemIssqn.EXEMPTION, label: 'Isenção' },
  { value: TaxCouponItemIssqn.EXPORT, label: 'Exportar' },
  { value: TaxCouponItemIssqn.IMMUNITY, label: 'Imunidade' },
  {
    value: TaxCouponItemIssqn.DEMAND_SUSPENDED_JUDICIAL_DECISION,
    label: 'Exigir decisão judicial suspensa',
  },
  {
    value: TaxCouponItemIssqn.DEMAND_SUSPENDED_ADMINISTRATIVE_PROCESS,
    label: 'Processo administrativo suspenso da demanda',
  },
  {
    value: TaxCouponItemIssqn.TAXABLE_OUTSIDE_CITY,
    label: 'Tributável fora da cidade',
  },
  {
    value: TaxCouponItemIssqn.TAXABLE_WITHIN_CITY,
    label: 'Tributável dentro da cidade',
  },
];

const TaxeIssqnSelect = forwardRef<BaseSelectRef, SelectProps>((props, ref) => {
  return (
    <Select
      {...props}
      showSearch
      optionFilterProp="label"
      ref={ref}
      options={data}
    />
  );
});

export default TaxeIssqnSelect;
